export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse bg-ink-900/70 rounded-lg ${className}`} />;
}

export function SkeletonCard({ height = 'h-24' }: { height?: string }) {
  return <div className={`card ${height} animate-pulse bg-ink-900/60`} />;
}

export function SkeletonList({ count = 5, height = 'h-20' }: { count?: number; height?: string }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} height={height} />
      ))}
    </div>
  );
}
